import styled from 'styled-components';

export const Summary = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 4px 0 16px;
`;

export const SummaryPill = styled.button`
  border: 1px solid ${(props) => props.border || '#d9d9d9'};
  background: ${(props) => props.background || '#fff'};
  color: ${(props) => props.color || '#595959'};
  border-radius: 14px;
  padding: 4px 12px;
  font-size: 13px;
  font-weight: 600;
  cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
`;

export const GridBox = styled.div`
  background: #fff;
  border: 1px solid #eee7f8;
  border-radius: 10px;
  overflow-x: auto;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 280px) repeat(12, minmax(46px, 1fr));
  align-items: center;
  min-width: 900px;
  border-top: 1px solid #f3f0f8;

  &.head {
    border-top: 0;
    background: #f5f2fa;
    font-size: 12px;
    font-weight: 600;
    color: #4a5163;
  }
`;

export const GridCell = styled.div`
  padding: 6px 4px;
  text-align: center;
`;

export const CustomerCell = styled.div`
  padding: 8px 14px;
  display: flex;
  flex-direction: column;
  min-width: 0;

  .name {
    font-size: 13px;
    font-weight: 600;
    color: #262626;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sub {
    font-size: 11px;
    color: #8c8c8c;
  }
`;

export const Legend = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
  margin-top: 12px;
  font-size: 12px;
  color: #595959;

  span {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  i.swatch {
    width: 14px;
    height: 14px;
    border-radius: 3px;
    display: inline-block;
  }
`;

export const Section = styled.div`
  margin-bottom: 22px;
`;

export const SectionTitle = styled.div`
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8c8c8c;
  margin-bottom: 8px;
`;

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid #eee7f8;
  border-radius: 8px;
  margin-bottom: 8px;

  .info {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .name {
    font-size: 13px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .meta {
    font-size: 12px;
    color: #8c8c8c;
  }
`;

export const PdfBadge = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: #b42318;
  border: 1px solid #f0a9a1;
  border-radius: 4px;
  padding: 2px 5px;
`;

export const Missing = styled.div`
  padding: 10px 12px;
  border: 1px dashed #f0a9a1;
  background: #fff8f7;
  border-radius: 8px;
  color: #b42318;
  font-size: 13px;
  margin-bottom: 8px;
`;

export const HistoryItem = styled.div`
  font-size: 12px;
  color: #595959;
  padding: 3px 0;

  .when {
    color: #8c8c8c;
    margin-right: 6px;
  }
`;

export const DrawerFooter = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 24px;
  background: #faf8fd;
  border-top: 1px solid #eee7f8;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: flex-end;
`;
